export const calcularTotal = (row) => {
  let suma = 0;
  row.forEach((r) => {
    suma += r.Precio * r.Cantidad;
  });
  return suma;
};
